import { render, staticRenderFns } from "./ImagemNivel.vue?vue&type=template&id=12740097&"
import script from "./ImagemNivel.vue?vue&type=script&lang=js&"
export * from "./ImagemNivel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports